/**
 * 将 pay_config.qr_code 转为可扫码图片
 */

export function getPayQrDirectImageSrc(qrCode) {
  const raw = qrCode == null ? '' : String(qrCode).trim()
  if (!raw) return ''
  if (/^data:image\//i.test(raw)) return raw
  if (/^https?:\/\//i.test(raw) && /\.(png|jpg|jpeg|gif|webp|bmp)(\?|#|$)/i.test(raw)) {
    return raw
  }
  if (raw.length > 200 && /^[A-Za-z0-9+/=\s]+$/.test(raw)) {
    return `data:image/png;base64,${raw.replace(/\s/g, '')}`
  }
  return null
}

function qrServerUrl(raw, width) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=${width}x${width}&data=${encodeURIComponent(raw)}`
}

/**
 * @param {string} qrCode
 * @param {{ width?: number }} [opts]
 * @returns {Promise<string>}
 */
export async function generatePayQrDataUrl(qrCode, opts = {}) {
  const raw = qrCode == null ? '' : String(qrCode).trim()
  if (!raw) return ''

  const direct = getPayQrDirectImageSrc(raw)
  if (direct) return direct

  const width = opts.width || 240
  try {
    const mod = await import(/* webpackChunkName: "qrcode" */ 'qrcode')
    const QRCode = mod && (mod.default || mod)
    if (QRCode && typeof QRCode.toDataURL === 'function') {
      return await QRCode.toDataURL(raw, {
        width,
        margin: 2,
        errorCorrectionLevel: 'M',
        type: 'image/png',
        color: { dark: '#000000ff', light: '#ffffffff' }
      })
    }
  } catch (e) {
    /* 无 qrcode 依赖时走公共图服务 */
  }
  return qrServerUrl(raw, width)
}
